import { Flex, Img, Link, Text, useBreakpointValue } from "@chakra-ui/react";

export function FootDesktop() {
  const isWideVersion = useBreakpointValue({
    base: false,
    xs: false,
    sm: false,
    md: true,
    lg: false,
    xl: true
  });

  return (
    <>
      <Flex direction="column" width="full">
        <Flex
          align="center"
          p="1rem"
          direction="column"
          width="full"
          height={"250px"}
          justifyContent="center"
          as="footer"
          backgroundColor="ll-gray.600"
          borderTopColor="ll-gray.100"
          borderTopWidth="10px"
          borderTopStyle="solid"
          alignSelf="flex-start"
          letterSpacing={"-1px"}
        >
          <Flex
            maxWidth={isWideVersion ? "1180px" : "980px"}
            width="100%"
            height="100%"
            justifyContent={{
              md: "space-between",
              lg: "space-between",
              xl: "space-between",
              "2xl": "space-between"
            }}
          >
            <Flex direction="column" alignItems="start" pt="25px" pb="25px">
              <Img
                src={"https://cdn.pneufree.com.br/LINGLONG/images/Geral/DESKTOP/ling-long-logo.svg"}
                width="250px"
                mt={"15px"}
                mb="10px"
                alt="Logo LingLong"
              />

              <Link
                href="https://transparencyreport.google.com/safe-browsing/search?url=LingLong.com.br"
                target="_blank"
                mb={"15px"}
              >
                <Img
                  src="https://cdn.pneufree.com.br/LINGLONG/images/Geral/loja-segura.svg"
                  width="164px"
                  height="51px"
                  mb="10px"
                  mt="1rem"
                  alt={"Loja Segura"}
                />
              </Link>
            </Flex>

            <Flex w={"70%"} justifyContent={"space-between"}>
              <Flex direction="column" pt="35px" pb="25px" w={"calc(100%/3)"}>
                <Text color={"ll-blue.main"} fontSize={"h2"} fontWeight={"500"} mb={"5px"}>
                  Links Úteis
                </Text>
                <Flex gap={"2px"} flexDir={"column"} color={"ll-gray.300"} fontSize={"text1"}>
                  <Link href="/ajuda/sobre" _hover={{ textDecoration: "none", opacity: "0.5" }}>
                    Quem somos
                  </Link>
                  <Link href="/ajuda" _hover={{ textDecoration: "none", opacity: "0.5" }}>
                    Central de ajuda
                  </Link>
                  <Link
                    href="/ajuda/privacidade-linglong"
                    _hover={{ textDecoration: "none", opacity: "0.5" }}
                  >
                    Política de privacidade
                  </Link>
                  <Link
                    href="/ajuda/contato-linglong"
                    _hover={{ textDecoration: "none", opacity: "0.5" }}
                  >
                    Contato
                  </Link>
                </Flex>
              </Flex>

              <Flex mr={{ lg: "0", lx: "-30px" }} pt="35px" w={"calc(100%/3)"}>
                <Flex direction="column">
                  <Text color={"ll-blue.main"} fontSize={"h2"} fontWeight={"500"} mb={"5px"}>
                    Vendas
                  </Text>
                  <Flex flexDir={"column"} color={"ll-gray.300"} fontSize={"text1"}>
                    <Text mb="1rem" color={"ll-green.main"}>
                      Dias úteis das 8h às 18h.
                    </Text>
                    <Link
                      _hover={{ textDecoration: "none", opacity: "0.5" }}
                      display="flex"
                      mb="10px"
                      href="tel:+5504140421100"
                      //passHref
                    >
                      <Img
                        src="https://cdn.pneufree.com.br/LINGLONG/images/Site/icons/phone.svg"
                        mr="10px"
                        width="21px"
                        height="21px"
                        alt="Phone Vendas"
                      />
                      <Text>(41) 4042-1100</Text>
                    </Link>

                    <Link
                      _hover={{ textDecoration: "none", opacity: "0.5" }}
                      display="flex"
                      href="mailto:sac@linglong.com.br"
                    >
                      <Img
                        src="https://cdn.pneufree.com.br/LINGLONG/images/mail.svg"
                        mr="10px"
                        width="21px"
                        height="21px"
                        alt="Email vendas"
                      />
                      <Text>sac@linglong.com.br</Text>
                    </Link>
                  </Flex>
                </Flex>
              </Flex>

              <Flex direction="column" pt="35px" pb="25px" w={"auto"}>
                <Text color={"ll-blue.main"} fontSize={"h2"} fontWeight={"500"} mb={"5px"}>
                  Pós-vendas
                </Text>
                <Text color={"ll-green.main"} mb="1rem" fontSize={"16px"}>
                  Dias úteis das 8h às 18h.
                </Text>

                <Flex flexDir={"column"} color={"ll-gray.300"} fontSize={"text1"}>
                  <Link
                    _hover={{ textDecoration: "none", opacity: "0.5" }}
                    display="flex"
                    mb="10px"
                    href="tel:+5504140421212"
                  >
                    <Img
                      src="https://cdn.pneufree.com.br/LINGLONG/images/Site/icons/phone.svg"
                      mr="10px"
                      width="21px"
                      height="21px"
                      alt="Phone Pós-Vendas"
                    />
                    <Text>(41) 4042-1212</Text>
                  </Link>
                  <Link
                    _hover={{ textDecoration: "none", opacity: "0.5" }}
                    display="flex"
                    href="mailto:sac@linglong.com.br"
                    //passHref
                  >
                    <Img
                      src="https://cdn.pneufree.com.br/LINGLONG/images/mail.svg"
                      mr="10px"
                      width="21px"
                      height="21px"
                      alt="Email Pós-Vendas"
                    />
                    <Text>sac@linglong.com.br</Text>
                  </Link>
                </Flex>
              </Flex>
            </Flex>
          </Flex>
        </Flex>
        <Flex
          w="full"
          h={"30px"}
          background={"linear-gradient(99.09deg, #0C4EA2 14.48%, #00A550 90.81%);"}
          justifyContent={"center"}
          alignItems={"center"}
        >
          <Text color={"ll-white.main"} fontSize={"text4"}>
            Loja Oficial LingLong Pneus operada por: Pneufree.com Brasil Ltda
            CNPJ: 11.891.896/0001-62 - R. Dep. Heitor Alencar Furtado, 3350 - 6º andar - 81200-528 -
            Curitiba - PR
          </Text>
        </Flex>
      </Flex>
    </>
  );
}
